import domReady from "@roots/sage/client/dom-ready";
import LazyLoader from "@scripts/core/LazyLoader.js";
import ProductBuilder from "@scripts/components/product/ProductBuilder.js";
import Gallery from "@scripts/components/product/plugins/Gallery.js";
import QuantityManager from "@scripts/components/QuantityManager.js";
import AddToCartBuilder from "@scripts/components/product/plugins/AddToCart/AddToCartBuilder.js";
import DefaultButton from "@scripts/components/product/plugins/AddToCart/Buttons/DefaultButton.js";
import RadioVariableSelector from "@scripts/components/product/plugins/RadioVariableSelector.js";
import VariationSwitcher from "@scripts/components/product/plugins/VariationSwitcher.js";
import Multipack from "@scripts/components/product/plugins/Multipack.js";
import Omnibus from "@scripts/components/product/plugins/Omnibus.js";

import "fslightbox";
import SingleProductDeliveryTimeCounter from "@scripts/components/product/plugins/SingleProductDeliveryTimeCounter.js";

class Product {
  init() {
    let productDomElement = document.querySelector("[data-single-product]");
    if (productDomElement) {
      let productType = productDomElement.dataset.singleProductType;

      let builder = new ProductBuilder();
      builder.setProductType(productType);
      builder.addPlugin(
        new Gallery(
          ["variable", "simple", "grouped", "external", "variation"],
          "splide",
        ),
      );
      builder.addPlugin(
        new SingleProductDeliveryTimeCounter(
          ["variable", "simple", "grouped", "external", "variation"],
          "[data-delivery-time-counter]",
        ),
      );

      // AddToCartBuilder
      // const addToCartBuilder = new AddToCartBuilder();
      // const addToCartButton = new DefaultButton(productType);
      // addToCartButton.setSize("normal");
      // addToCartBuilder.setProductType(productType);
      // addToCartBuilder.setAddToCartButton(addToCartButton);
      // addToCartBuilder.setAddToCartMode("ajax");
      // addToCartBuilder.setQuantityInput(false);
      // addToCartBuilder.setStickyMode(false);
      // addToCartBuilder.setAddToCartWrapperSelector(
      //   '[data-sticky-add-to-cart="root"]',
      // );
      // addToCartBuilder.setOriginAddToCartFormSelector("form.cart");
      // builder.addPlugin(addToCartBuilder.build());

      builder.addPlugin(new VariationSwitcher(["variable"]));
      builder.addPlugin(new Multipack(["variable", "simple"], productType));
      builder.addPlugin(new Omnibus(["variable"]));

      let product = builder.build();
      product.init();
    }
  }
}

class QuantityModulesBuilder {
  #quantity_module_wrapper_selector = null;
  #origin_module_parent_selector = "form.cart";
  #callbacks = [];

  setModuleWrapperSelector(selector) {
    this.#quantity_module_wrapper_selector = selector;
    return this;
  }

  setOriginModuleParentSelector(selector) {
    this.#origin_module_parent_selector = selector;
    return this;
  }

  addCallback(callback) {
    this.#callbacks.push(callback);
    return this;
  }

  build() {
    if (
      !this.#quantity_module_wrapper_selector ||
      !this.#origin_module_parent_selector
    ) {
      throw new Error("QuantityModulesHandler: No wrapper selector provided");
    }
    return new QuantityManager(
      this.#quantity_module_wrapper_selector,
      this.#origin_module_parent_selector,
      this.#callbacks,
    );
  }
}

function updateCartItemQuantity(wrapper = null, input = null) {
  const updateCartButton = document.querySelector('button[name="update_cart"]');
  if (updateCartButton) {
    updateCartButton.disabled = false;
    updateCartButton.click();
    updateCartButton.disabled = true;
  }
}

const quantityInputsModule = () => {
  const QuantityModulesBuilderInstance = new QuantityModulesBuilder();
  QuantityModulesBuilderInstance.setModuleWrapperSelector(
    "[data-product-quantity-input-wrapper]",
  );
  QuantityModulesBuilderInstance.setOriginModuleParentSelector("form.cart");
  QuantityModulesBuilderInstance.addCallback(updateCartItemQuantity);
  const QuantityManagerInstance = QuantityModulesBuilderInstance.build();
  QuantityManagerInstance.init();
};

const initExpressDelivery = () => {
  // Event delegation - checkbox is inside WC fragments that get replaced on update_checkout.
  // No custom AJAX needed: WC's native update_checkout serializes the form (including
  // the checkbox state) and our PHP hook update_express_delivery_from_post syncs it to session.
  jQuery(document.body).on(
    "change",
    '.js-express-delivery-checkbox input[type="checkbox"]',
    function () {
      jQuery(document.body).trigger("update_checkout");
    },
  );
};

/**
 * Initialize sticky add to cart bar
 */
function initStickyAddToCart() {
  const stickyBar = document.getElementById('sticky-add-to-cart');
  const addToCartForm = document.querySelector('form.cart');

  if (!stickyBar || !addToCartForm) {
    return;
  }

  let lastScrollPosition = 0;
  const scrollThreshold = 300;

  const handleScroll = () => {
    const currentScrollPosition = window.scrollY;
    const formRect = addToCartForm.getBoundingClientRect();

    // Show sticky bar when original add-to-cart form is not visible
    // and we've scrolled past the threshold
    const isFormVisible = (
      formRect.top < window.innerHeight &&
      formRect.bottom > 0
    );

    // On mobile, hide the sticky bar when the substrate calculator is visible
    let isSubstrateCalculatorVisible = false;
    if (window.innerWidth < 1024) {
      const substrateCalculator = document.getElementById('substrate-calculator');
      if (substrateCalculator) {
        const calcRect = substrateCalculator.getBoundingClientRect();
        isSubstrateCalculatorVisible = (
          calcRect.top < window.innerHeight &&
          calcRect.bottom > 0
        );
      }
    }

    if (!isFormVisible && currentScrollPosition > scrollThreshold && !isSubstrateCalculatorVisible) {
      stickyBar.classList.add('is-visible');
    } else {
      stickyBar.classList.remove('is-visible');
    }

    lastScrollPosition = currentScrollPosition;
  };

  // Throttle scroll events
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Initial check
  handleScroll();
}

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(async () => {
  const lazyLoader = new LazyLoader();
  lazyLoader.registerMethod(quantityInputsModule, "quantityInputsModule");

  const product = new Product();
  product.init();

  // Checkout fee
  initExpressDelivery();

  // Sticky add to cart bar
  initStickyAddToCart();
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
